module.exports = __webpack_public_path__ + "1793882494189/images/doc.52186d4.svg";